var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _radialGradient, _path11, _path12, _path13, _path14, _path15, _path16, _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMsTeamsWelcome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 280 173.2",
    style: {
      width: "100%",
      height: "100%"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M166 126.3l20-93L263.8 50l-20 93z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E66693",
    d: "M175.7 108l14.6-68L257 54.3l-14.7 68z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M166 141.4l34.6-95L280 75.1l-34.6 95.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EF9FBB",
    d: "M177.7 124l26-71.3 70 25.5-26 71.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M246.8 128.7c.5-4.6 7-6.6 6.5-11.3-.5-4.8-6-6.4-7.4-11.3a22 22 0 01.6-10.7L235.9 81l-2.6 3.8.6-4-17.3 3.6s-2.6 5.6-6.9 8.3-9 1-12.5 4.1-.4 8.4-3.2 12.2c-2.1 3-7.8 1.3-11.6 2.4l-4.6 12.5v.2l70 25.4 4.6-12.8c-2.5-2.7-5.9-5-5.6-8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M215.7 86.5a17 17 0 00.3 12.7c1.7 3.9 4.8 7 9 8.5h.2a16.2 16.2 0 0020.7-10.2 15 15 0 00-.3-11 13.8 13.8 0 00-7.7-7.4l-4.2-1.6c-2-.7-3.9-.9-5.8-.7-5.3.5-10.2 4.1-12.2 9.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FADCBD",
    d: "M218.4 113.6l4-11.1 8 2.8-4 11.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FADCBD",
    d: "M224.3 106.8l1.9.7c5.4 2 11.3-.8 13.3-6.2l.6-1.6a9 9 0 00-5.4-11.6l-4.4-1.5a9 9 0 00-11.6 5.3l-.6 1.6c-2 5.4.9 11.3 6.2 13.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M215.4 89.6a8 8 0 0013.3-2.2l6.5 2.4a8 8 0 009 10.2c.2-.6-.8-12.3-.8-12.3l-20-7.2s-7.9 8.5-8 9z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0BB95",
    d: "M228.6 87.4l3.3 1.2a1.8 1.8 0 00-3.3-1.2z"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: -7.3,
    cy: -52.6,
    r: 6.6,
    gradientTransform: "matrix(-.9395 -.3425 .5744 -1.5754 253.3 .5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9689c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#b8afd5",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M235.3 79l-3.5 9.6 3.4 1.2a8 8 0 009 10.2c.1-.4-2-5.4.9-12.4l-9.8-8.5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0BB95",
    d: "M231.9 88.6l3.3 1.2a1.8 1.8 0 00-3.3-1.2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#8B8CC4",
    d: "M224.6 113.2l-2.7-1a22.2 22.2 0 00-28.5 13.4l-1.4 3.7 44.5 16.2 1.4-3.8a22.2 22.2 0 00-13.3-28.5z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#FADCBD",
    d: "M216.1 111c.9 1.9 3.1 3.7 6 4.8 3 1 5.9 1 7.7.2-1.5-1.2-3.3-2-5.2-2.8l-2.7-1c-2-.7-3.9-1-5.8-1.2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#C3C3E1",
    d: "M88.8 0h103.4v133H88.8z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#E66693",
    d: "M161.6 11.6H151a1 1 0 00-.8 1.4l5.3 9.2a1 1 0 001.7 0l5.3-9.2a1 1 0 00-.9-1.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E66693",
    d: "M137.5 26.4l-4.9-7.9-14.7 7-1.3-2.7 17.1-8.1 4.9 7.8 14.4-6.8 1.3 2.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#8B8CC4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.1 82.8h64.8v5h-64.8zM108.1 95.6h64.8v5h-64.8zM108.1 108.3h64.8v5h-64.8z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#8B8CC4",
    d: "M177.2 70.4h-69.9v-3h66.9V25.9h3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8B8CC4",
    d: "M154 29.9h14.2v32H154zM132.8 35.3H147V62h-14.2zM111.6 47.7h14.2v14.2h-14.2z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F3F2F1",
    d: "M105.1 48l28.2 89.4-96.2 30.2L0 49.8l67.7-21.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E1DFDD",
    d: "M105.1 48l-28.4 8.9-9-28.4zM58 84.1l36.7-11.6 1.7 5.4-36.8 11.6zM35.9 106.3l63.2-20 1.7 5.4-63.2 20zM40.3 120l63.2-19.8 1.7 5.3-63.2 20zM44.6 133.9l63.2-20 1.7 5.4-63.2 20zM53.6 70.3l36.8-11.6 1.7 5.4-36.8 11.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EF9FBB",
    d: "M46.5 72.6l6 19.2-19.2 6-6-19.1 19.2-6.1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsTeamsWelcome);
export default __webpack_public_path__ + "static/media/MsTeamsWelcome.0e6b131a.svg";
export { ForwardRef as ReactComponent };